'use es6';

export const getBodyScrollBounds = () => {
  return {
    scrollLeft: document.body.scrollLeft,
    scrollTop: document.body.scrollTop
  };
};
export const adjustMouseCoordsForAnyChangeInScroll = (mouseCoordinates, previousScrollBounds, currentScrollBounds) => {
  const result = {
    x: mouseCoordinates.x,
    y: mouseCoordinates.y
  };
  if (previousScrollBounds.scrollLeft !== currentScrollBounds.scrollLeft) {
    const delta = currentScrollBounds.scrollLeft - previousScrollBounds.scrollLeft;
    result.x += delta;
  }
  if (previousScrollBounds.scrollTop !== currentScrollBounds.scrollTop) {
    const delta = currentScrollBounds.scrollTop - previousScrollBounds.scrollTop;
    result.y += delta;
  }
  return result;
};
export const convertClientOffsetToPageCoordinates = clientCoords => {
  return {
    x: clientCoords.x + window.scrollX,
    y: clientCoords.y + window.scrollY
  };
};